// 🚨 Auto-generated file. Do not edit manually.

export const logoImages = {
  appleTouchIcon: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1744314821/mad-web-app/logo-images/apple-touch-icon.png',
    publicId: 'mad-web-app/logo-images/apple-touch-icon',
    alt: 'Apple Touch Icon Logo Image',
  },
  madBadge: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741893335/mad-web-app/logo-images/mad-badge.png',
    publicId: 'mad-web-app/logo-images/mad-badge',
    alt: 'Mad Badge Logo Image',
  },
  solarFx: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741887881/mad-web-app/logo-images/solar-fx.png',
    publicId: 'mad-web-app/logo-images/solar-fx',
    alt: 'Solar Fx Logo Image',
  },
  madGoogleBadge: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741883235/mad-web-app/logo-images/mad-google-badge.png',
    publicId: 'mad-web-app/logo-images/mad-google-badge',
    alt: 'Mad Google Badge Logo Image',
  },
  systemXAuthorizedInstaller: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740581207/mad-web-app/logo-images/system-x-authorized-installer.png',
    publicId: 'mad-web-app/logo-images/system-x-authorized-installer',
    alt: 'System X Authorized Installer Logo Image',
  },
  favicon: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1735430114/mad-web-app/logo-images/favicon.png',
    publicId: 'mad-web-app/logo-images/favicon',
    alt: 'Favicon Logo Image',
  },
};
